// extracted by mini-css-extract-plugin
export default {"tooltip":"RW8tK","text":"o89F_"};